export const featureFlag = {
  changeFacilitySearch: true,
  globalSearch: false,
  psnAlertGrid: false,
  watchList: true,
  recent: false,
  notificationSettings: true,
  rrDashboardFilter: false,
  includeLastWeekAndMonthDashboardFilter: false,
  maskName: false,
  appUpdateModal: false,
  rtSettingsEmailList: [
    "stefan@circadia.health",
    "zach@circadia.health",
    "touqeer_cip@circadia.health",
    "umer@circadia.health",
    "umer_cip@circadia.com",
    "abdullah_ghaznavi@circadia.health",
  ],
};
